<template>
  <div class="bj-section">
    <div class="ubold-title">个人资料</div>
    <div class="bjrow">
      <div class="name">用户ID：</div>
      <div class="label">{{ user.id }}</div>
    </div>
    <div class="bjrow">
      <div class="name">真实姓名：</div>
        <div class="label t-row" v-if="user.name">
          <Input
            class="bj-input-26262A bj-input-h45"
            disabled
            type="text"
            v-model="user.name"
            placeholder="请输入真实姓名"
            clearable
            style="width: 300px"
          ></Input>
        </div>
        <div class="label" v-else>
          <router-link to="/my/user/certified"
            >未实名认证，请前往认证</router-link
          >
        </div>
    </div>
    <div class="bjrow">
      <div class="name">昵称：</div>
      <div class="label">
        <Input
            class="bj-input-26262A bj-input-h45"
            type="text"
            v-model="form.nickname"
            placeholder="请输入昵称"
            style="width: 300px"
            clearable
          ></Input>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">出生日期：</div>
      <div class="label">
        <DatePicker
          class="bj-bg-color-26262A date-time-h45"
          v-model="form.birthday"
          @on-change="handleChange"
          type="date"
          format="yyyy-MM-dd"
          placeholder="请输入出生日期"
          style="width: 300px"
          clearable
        ></DatePicker>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">联系电话：</div>
      <div class="label">
        <Input
            class="bj-input-26262A bj-input-h45"
            disabled
            type="text"
            v-model="user.mobile"
            placeholder="请输入联系电话"
            style="width: 300px"
            clearable
          ></Input>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">联系QQ：</div>
      <div class="label">
        <Input
          class="bj-input-26262A bj-input-h45"
          type="text"
          v-model="form.qq"
          placeholder="请输入联系QQ"
          style="width: 300px"
          clearable
        ></Input>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">微信号：</div>
      <div class="label t-row">
        <Input
            class="bj-input-26262A bj-input-h45"
            type="text"
            v-model="form.wechat"
            placeholder="请输入微信号"
            style="width: 300px"
            clearable
          ></Input>
          <Button
            class="bj-h45 bj-btn-color-26262A"
            style="margin-left: 20px"
            v-if="form.wechatImg"
            @click="showWechat"
            >查看微信头像</Button
          >
          <Upload
            class="upload"
            style="margin-left: 20px; border: none"
            type="drag"
            :before-upload="handleBeforeUpload"
            :show-upload-list="false"
            action="/"
          >
            <Button class="bj-h45 bj-btn-color-26262A">添加微信头像</Button>
          </Upload>
      </div>
    </div>
    <div class="bjrow">
      <div class="name required">省份-城市：</div>
      <div class="label">
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-model="form.province"
          filterable
          style="margin-right: 10px; width: 300px"
          @on-change="changeProvince"
        >
          <Option
            v-for="(item, index) in areas"
            :key="'p' + index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          class="select-h45 bj-bg-color-26262A"
          v-if="form.province != null && form.province != ''"
          v-model="form.city"
          style="margin-right: 10px; width: 300px"
          filterable
        >
          <Option
            v-for="item in cityList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">联系地址：</div>
      <div class="label">
        <Input
            class="bj-input-26262A bj-input-h45"
            type="text"
            v-model="form.address"
            placeholder="请输入联系地址"
            style="width: 300px"
            clearable
          ></Input>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">邮政编码：</div>
      <div class="label">
        <Input
            class="bj-input-26262A bj-input-h45"
            type="text"
            v-model="form.postcode"
            placeholder="请输入邮政编码"
            style="width: 300px"
            clearable
          ></Input>
      </div>
    </div>
    <div class="bjrow">
      <div class="name">传真号码：</div>
      <div class="label">
        <Input
            class="bj-input-26262A bj-input-h45"
            type="text"
            v-model="form.fax"
            placeholder="请输入传真号码"
            style="width: 300px"
            clearable
          ></Input>
      </div>
    </div>
    <Button
      :loading="loading"
      type="primary"
      class="bj-w120 bj-h45 bj-confirm-btn"
      @click="onConfirm"
      >确认修改</Button
    >
    <!-- 查看头像 -->
    <userImageModal
      :show.sync="userImageModalVisibility"
      :data="form.wechatImg"
    ></userImageModal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import userImageModal from "components/account/userImageModal.vue";
import { userEdit, uploadPicture } from "api/user.js";
import { getRegionList } from "api/domain.js";

export default {
  name: "account",
  components: {
    userImageModal,
  },
  data() {
    return {
      form: {
        nickname: "",
        sex: 0,
        birthday: "",
        qq: "",
        wechat: "",
        province: "",
        city: "",
        area: "",
        address: "",
        postcode: "",
        fax: "",
        wechatImg: "",
        file: "",
      },
      format: "yyyy-MM-dd",
      areaList: [],
      cityList: [],
      loading: false,
      userImageModalVisibility: false,
    };
  },
  computed: {
    ...mapState(["user", "areas"]),
  },
  async created() {
    if (this.areas.length === 0) {
      await this.req_getRegionList();
    }
    this.valueData();
  },
  methods: {
    ...mapActions(["ACT_REGION_LIST"]),
    ...mapMutations(["MUT_USER_PART_INFO", "MTU_REGION_LIST", "MUT_USER_INFO"]),
    valueData() {
      this.form.nickname = this.user.nick;
      this.form.sex = this.user.sex;
      this.form.birthday = this.user.birthday;
      this.form.qq = this.user.qqNum;
      this.form.wechat = this.user.wechatNum;
      this.form.province = this.user.province;
      this.form.area = this.user.region;
      this.form.address = this.user.addr;
      this.form.postcode = this.user.postcode;
      this.form.fax = this.user.fax;
      this.form.wechatImg = this.user.wechatImg;

      if (this.form.province) {
        this.changeProvince();
        this.form.city = this.user.city;
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      this.form.file = file;
      this.form.wechatImg = window.URL.createObjectURL(file);
      this.$Message.success("微信图片添加成功，记得点击确认进行保存哦！");
      return false;
    },
    // 省改变
    changeProvince() {
      if(this.areas && this.areas.length > 0){
        let selectArray = this.areas.filter(
          (o) => o.value === this.form.province
        );
        this.cityList = selectArray[0].children;
        this.form.city = "";
      }
      
    },
    // 查看微信头像
    showWechat() {
      this.userImageModalVisibility = true;
    },
    // 时间变化
    handleChange(val) {
      console.log(val);
      this.form.birthday = val;
    },
    // 确认
    async onConfirm() {
      try {
        if (!this.form.nickname) {
          this.$Message.warning("请输入昵称！");
          return;
        }
        if (!this.form.province || !this.form.city) {
          this.$Message.warning("请选择省份-城市！");
          return;
        }
        this.loading = true;
        if (this.form.file) {
          const formData = new FormData();
          formData.append("file", this.form.file);
          const res = await uploadPicture(formData);
          if (res.code === 200 && res.result) {
            this.form.wechatImg = res.data.url;
          } else {
            this.loading = false;
            return;
          }
        }
        if(this.form.birthday instanceof Date){
          this.form.birthday = this.form.birthday.pattern('yyyy-MM-ddd');
        }
      
        const params = {
          addr: this.form.address,
          district: this.form.area,
          birthday: this.form.birthday,
          city: this.form.city,
          email: this.form.email,
          fax: this.form.fax,
          nick: this.form.nickname,
          postcode: this.form.postcode,
          province: this.form.province,
          qq: this.form.qq,
          sex: this.form.sex,
          wechat: this.form.wechat,
          img: this.form.wechatImg,
        };
        const { code, result } = await userEdit(params);
        this.loading = false;
        if (code === 200 && result) {
          this.$Message.success("修改成功");
          let obj = {
            nick: this.form.nickname,
            sex: this.form.sex,
            qqNum: this.form.qq,
            wechatNum: this.form.wechat,
            province: this.form.province,
            city: this.form.city,
            region: this.form.area,
            addr: this.form.address,
            postcode: this.form.postcode,
            fax: this.form.fax,
            wechatImg: this.form.wechatImg,
            name: this.user.name,
            id: this.user.id,
            mobile: this.user.mobile,
          }
          this.MUT_USER_INFO(obj);
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // 获取地区信息
    async req_getRegionList() {
      try {
        const { code, data } = await getRegionList();
        if (code === 200) {
          this.MTU_REGION_LIST(data);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bj-section {
  background-image: linear-gradient(155deg,#352322 9%, #202224 13%);
  border-radius: 8px;
  padding: 30px 50px 50px;
  .bjrow {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .name {
      min-width: 80px;
      font-size: 14px;
      line-height: 20px;
      color: #737577;
    }
    .name.required {
      &::before {
        content: "*";
        color: #ed1d33;
        margin-right: 5px;
      }
    }
    .label {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
    }
  }
  .bjcol-group {
    display: flex;
    .bjcol {
      min-width: 300px;
      margin-bottom: 20px;
      &:last-child {
        margin-left: 60px;
      }
      .name {
        min-width: 80px;
        font-size: 14px;
        line-height: 20px;
        color: #737577;
        margin-bottom: 20px;
      }
      .name.required {
        &::before {
          content: "*";
          color: #ed1d33;
          margin-right: 5px;
        }
      }
      .label {
        font-size: 14px;
        line-height: 20px;
        color: #737577;
      }
    }
  }
  .t-row {
    display: flex;
    align-items: center;
  }
}
::v-deep .upload {
  .ivu-upload-drag {
    border: none;
    background: transparent;
  }
}
</style>
